import {$, createElement, getParentElementById} from "../../core/js/Dom.ts";
import {debounce} from "lodash-es";
import {fadeIn, fadeOut} from "../../core/js/Animate.ts";
import {checkIfDateIsBefore} from "../../core/js/Utils.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url?.startsWith("manifestation_non_revendicative")) {
        initState()
    }
})

function initState() {
    if (window.Openscop.commune) {
        $('#id_ville_depart')?.addEventListener('field:changed', debounce(setCommune, 1000))
    }

    if (window.Openscop.arrondissements) {
        const arrondissements = $('#id_arrondissements_municipaux_m2m')
        arrondissements?.addEventListener('field:changed', debounce(setArrondissements, 500))
        arrondissements?.addEventListener('field:changed', updateArrondissementsVisibility)
    }

    const collapses = ["#collapse_nombre_agent_securite_int", "#collapse_nombre_personne_encadrement_int",
        "#collapse_vente_alcool_message", "#collapse_date_montage", "#collapse_deambulatoire_chaussee_b",
        "#collapse_fermeture_des_voies_b", "#collapse_neutralisation_stationnement_b"];
    ['presence_agent_securite_b', 'presence_encadrement_b', 'vente_alcool_b',
        'installations_b', 'deambulatoire_b', 'fermeture_des_voies_b', 'neutralisation_stationnement_b'].forEach((selector: string, index: number) => {
        if ($<HTMLInputElement>(`[name="${selector}"]`)?.checked) {
            setTimeout(() => {
                window.dsfr($(collapses[index]))?.collapse?.disclose()
            }, 1000)
        }
    })

    const dateChamps = ['#id_date_debut', '#id_date_fin', '#id_date_montage', '#id_date_demontage']
    dateChamps.forEach(id => {
        $(id)?.addEventListener('change', debounce(compareDates, 300))
    })
}


function setCommune(event: DOMEvent<HTMLSelectElement>) {
    event.target.slim?.setSelected(window.Openscop.commune)
}

function setArrondissements(event: DOMEvent<HTMLSelectElement>) {
    event.target.slim?.setSelected(window.Openscop.arrondissements)
}

function updateArrondissementsVisibility(event: DOMEvent<HTMLSelectElement>) {
    setTimeout(() => {
        if (event.target.options.length > 0) {
            fadeIn(getParentElementById(event.target, 'div_id_arrondissements_municipaux_m2m')).catch()
        } else {
            fadeOut(getParentElementById(event.target, 'div_id_arrondissements_municipaux_m2m')).catch()
        }
    }, 500)
}


function compareDates() {
    const form = $<HTMLFormElement>('#manifestation-form')
    if (form) {
        const erreurs: string[] = []
        const erreurContainer = $('#erreur-date')
        const data = new FormData(form)
        const hasMontage = data.get('installations_b')

        const dateDebut = new Date(data.get('date_debut') as string)
        const dateFin = new Date(data.get('date_fin') as string)
        const dateMontage = new Date(data.get('date_montage') as string)
        const dateDemontage = new Date(data.get('date_demontage') as string)


        if (!checkIfDateIsBefore(dateDebut, dateFin)) {
            erreurs.push(showDateErreur("début", "fin"))
        }
        if (hasMontage) {
            if (!checkIfDateIsBefore(dateDebut, dateDemontage)) {
                erreurs.push(showDateErreur("début", "démontage"))
            }
            if (!checkIfDateIsBefore(dateFin, dateDemontage)) {
                erreurs.push(showDateErreur("fin", "démontage"))
            }
            if (!checkIfDateIsBefore(dateMontage, dateDebut)) {
                erreurs.push(showDateErreur("montage", "début"))
            }
            if (!checkIfDateIsBefore(dateMontage, dateFin)) {
                erreurs.push(showDateErreur("montage", "fin"))
            }
            if (!checkIfDateIsBefore(dateMontage, dateDemontage)) {
                erreurs.push(showDateErreur("montage", "démontage"))
            }
        }
        if (erreurContainer) {
            erreurContainer.innerHTML = ""
            if (erreurs.length > 0) {
                erreurContainer.appendChild(renderErrors(erreurs))
                fadeIn(erreurContainer).catch()
            } else {
                fadeOut(erreurContainer).catch()
            }
        }
    }
}

function renderErrors(erreurs: string[]) {
    const ul = createElement('ul')

    erreurs.forEach(erreur => {
        const li = createElement('li')
        li.textContent = erreur
        ul.appendChild(li)
    })

    return ul
}

function showDateErreur(dateStart: string, dateFin: string) {
    return `La date de ${dateStart} ne peut pas être après la date de ${dateFin}`
}